import { applySearchCRMRequestOptionsChanges } from 'email-management-lib/Shared/apis/crmSearch';
import { CRM_SEARCH_REQUEST_DEFAULT_OPTIONS, DEFAULT_FILTERS, DEFAULT_VIEW_PATH, MARKETING_EMAIL_OBJECT_TYPE, PROPERTIES, PUBLISH_STATUS } from 'email-management-lib/Shared/constants/frameworkTable';
import { AFFECTED_EMAILS_URL_REG, FOLDER_URL_REG, MANAGE_URL_REG } from 'email-management-lib/Shared/constants/manage';
import { EQ, HAS_PROPERTY, IN, LT_X_DAYS } from 'email-management-lib/Shared/utils/filters';
import { removeDuplicatedFilterOperators } from 'framework-listing-lib/utils/filters';
import quickFetch from 'quick-fetch';
import { HAS_CREATED_EMAILS_EARLY_REQUEST_ID } from './constants';
export const ISSUE_DAYS = 90;
export function getViewFromPathname(pathname) {
  const match = pathname.match(MANAGE_URL_REG);
  const view = (match || [])[1];
  return view;
}
export function getQueryFromSearch(search) {
  return new URLSearchParams(search).get('search');
}
export function isFolderPathname(pathname) {
  return FOLDER_URL_REG.test(pathname);
}
export function isAffectedEmailsPathname(pathname) {
  return AFFECTED_EMAILS_URL_REG.test(pathname);
}
export function getWindowPathname() {
  return window.location.pathname;
}
export function getWindowSearch() {
  return window.location.search;
}
export function getHasCreatedEmailsEarlyRequest() {
  return quickFetch.getRequestStateByName(HAS_CREATED_EMAILS_EARLY_REQUEST_ID);
}
export function removeHasCreatedEmailsEarlyRequest() {
  return quickFetch.removeEarlyRequest(HAS_CREATED_EMAILS_EARLY_REQUEST_ID);
}
export function getEarlyViewsRequest() {
  return quickFetch.getRequestStateByName(`crm-listing-pinned-views-${MARKETING_EMAIL_OBJECT_TYPE}-MARKETING_EMAIL-v4`);
}
export function getEarlyRequestedDefaultViewId() {
  const viewsRequest = getEarlyViewsRequest();
  // We default to the left-most view (first in array)
  return viewsRequest && viewsRequest.data && viewsRequest.data.results[0] &&
  // Type says it can only be a String, it can actually come back a Number
  String(viewsRequest.data.results[0].id) || undefined;
}
export function getSearchOptions({
  view,
  query,
  currentUserId
}) {
  if (typeof view === 'object') {
    const filterGroups = JSON.parse(view.filterGroups).map(filterGroup => ({
      // removeDuplicatedFilterOperators favors first elements over last
      filters: removeDuplicatedFilterOperators([...filterGroup.filters, ...(view.quickFilters ? JSON.parse(view.quickFilters) : []), ...DEFAULT_FILTERS])
    }));
    return applySearchCRMRequestOptionsChanges({
      requestOptions: Object.assign({}, CRM_SEARCH_REQUEST_DEFAULT_OPTIONS, {
        filterGroups,
        query: query || ''
      }),
      currentUserId
    });
  }
  let filters = [...DEFAULT_FILTERS, IN(PROPERTIES.ARCHIVED, ['false'])];
  if (view === DEFAULT_VIEW_PATH.DRAFT) {
    filters.push(IN(PROPERTIES.PUBLISH_STATUS, [PUBLISH_STATUS.DRAFT]));
  } else if (view === DEFAULT_VIEW_PATH.SCHEDULED) {
    filters.push(IN(PROPERTIES.PUBLISH_STATUS, [PUBLISH_STATUS.SCHEDULED]));
  } else if (view === DEFAULT_VIEW_PATH.SENT) {
    filters.push(IN(PROPERTIES.PUBLISH_STATUS, [PUBLISH_STATUS.PUBLISHED]));
  } else if (view === DEFAULT_VIEW_PATH.AI_GENERATED) {
    filters.push(EQ(PROPERTIES.IS_AI_USED, 'true'));
  } else if (view === DEFAULT_VIEW_PATH.ARCHIVED) {
    filters = [...DEFAULT_FILTERS, IN(PROPERTIES.ARCHIVED, ['true'])];
  } else if (view === DEFAULT_VIEW_PATH.ISSUES) {
    filters.push(HAS_PROPERTY(PROPERTIES.ERROR_TAGS), LT_X_DAYS(PROPERTIES.ERROR_DATE, ISSUE_DAYS, {
      upperBoundInclusive: true,
      lowerBoundInclusive: true,
      direction: 'BACKWARD'
    }));
  } else if (view === DEFAULT_VIEW_PATH.DELETED) {
    filters = [...DEFAULT_FILTERS, HAS_PROPERTY(PROPERTIES.DELETED_DATE)];
  }
  let sorts = CRM_SEARCH_REQUEST_DEFAULT_OPTIONS.sorts;
  if (view === DEFAULT_VIEW_PATH.ISSUES) {
    sorts = [{
      order: 'DESC',
      property: PROPERTIES.ERROR_DATE
    }];
  } else if (view === DEFAULT_VIEW_PATH.DELETED) {
    sorts = [{
      order: 'DESC',
      property: PROPERTIES.DELETED_DATE
    }];
  }
  return Object.assign({}, CRM_SEARCH_REQUEST_DEFAULT_OPTIONS, {
    filterGroups: [{
      filters
    }],
    query: query || '',
    sorts
  });
}